// Import react elements
import React from "react";

// Import css
import "./CreateButton.css"; // Import styles



// Create a button based on values passed in
const CreateButton = ({

    // Default size m
    size = "m",

    // Default --primary-colour so send color if you don't want the primary value - background colour
    color = "var(--primary-color)",

    // Font color so the button can be fully customised
    textColor = "",

    // Border so the button can be fully customised
    border = "",

    // Default use gradient = false
    gradient = false,

    // Defualt is full width = false
    fullWidth = false,

    // Default type is button (could be submit)
    type = "button",

    // Defualt is false
    disabled = false,

    // An icon if it's passed in
    icon,

    // The alt text for an icon image
    iconTitle,

    // The title if it's passed in
    title,

    // OnClick function passed in
    onClick,

    // Hover title
    tooltip,

    className,

    // If inverted flip background color, border and text colour
    invert = false,

    // If the button overlays an image or element style it differently
    overlay = false,

    // If the button is just plain it will have no background and the text should match the existing theme
    plain = false,

    // Form id if this button is for a form's submit button
    formID,

    // Is this the delete button - if so give it a red background colour
    isDelete = false,

    // Is this the cancel button - if so give it a red border and text colour
    isCancel = false,


}) => {

    return (

        <button

            type={type}

            className={`btn btn-${size} btn-${color} ${className} ${fullWidth ? "btn-fullwidth" : ""} ${invert ? "btn-invert" : ""} ${overlay ? "btn-overlay" : ""} ${plain ? "btn-plain" : ""} ${isCancel ? "btn-cancel" : ""} ${isDelete ? "btn-delete" : ""}`}

            style={{

                background: invert ?

                    "var(--surface-color)"

                    :
                
                    gradient ?

                        `linear-gradient(45deg, ${color}, var(--primary-color-dark))`

                        :

                        overlay ?

                            '#ffffff63'

                            :

                                plain ?

                                    '#ffffff00'

                                    :

                            color,
                color: textColor,
                border: border,

            }}

            onClick={
                
                type === "submit" ?

                    // Use the onClick fuction as is if the button type is a form submit
                    onClick

                :     

                    // Otherwise capture the event to prevent dom issues
                    (event) => {

                        // Stop the click bubbling up
                        event.stopPropagation();
                        event.preventDefault();
                        event.currentTarget.blur();

                        // Run the onClick function
                        onClick(event);

                    }
                    
            }

            disabled={disabled}

            title={tooltip}

            form={formID}

        >

            {icon && <img src={icon} alt={iconTitle} className="btn-icon" />}

            {title && <span className="btn-title">{title}</span>}

        </button>

    );

};

export default CreateButton;
